import { auth } from "../firebase/firebase";

// Session Firebase figee au debut d'une operation asynchrone (ADR-017),
// utilisable hors React (services, transport, geolocalisation). Meme intention
// que le numero de session de AppContext (ADR-005 §9).
//
// Une operation reste valable tant que les trois restent identiques :
// - l'objet auth.currentUser : le SDK installe (@firebase/auth) en pose un
//   nouveau a chaque connexion, deconnexion ou changement de compte, dans cet
//   onglet comme depuis un autre onglet (_updateCurrentUser) ;
// - son uid ;
// - metadata.lastSignInTime : quand un autre onglet synchronise le MEME uid,
//   le SDK reutilise l'objet et recopie ses donnees (_onStorageEvent ->
//   _assign) ; une nouvelle connexion change cette date, un simple
//   renouvellement de jeton non.
// Verifie a la lecture du SDK installe ; les tests simulent ces objets, ils ne
// prouvent pas le comportement reel de Firebase (protocole manuel : spec
// member-location-coverage, section B).
function signInMarker(user) {
  return user?.metadata?.lastSignInTime ?? null;
}

// isAnonymous est fige a la capture : la conversion d'un compte anonyme en
// membre (linkWithCredential, meme objet et meme uid d'apres le SDK) ouvre une
// nouvelle session. Une operation demarree anonymement n'est jamais valable
// pour le membre qui en resulte.
export function captureAuthSession() {
  const user = auth.currentUser || null;
  const uid = user?.uid || null;
  const marker = signInMarker(user);
  const isAnonymous = Boolean(user?.isAnonymous);
  return {
    uid,
    user,
    isAnonymous,
    isCurrent: () => Boolean(user)
      && auth.currentUser === user
      && user.uid === uid
      && signInMarker(user) === marker
      && Boolean(user.isAnonymous) === isAnonymous,
  };
}
